import { initApiButtons } from "../utils.js";
function run() {
    $(() => {
        console.log('Initialized Page Script...');
        initApiButtons();
    });
}
function resizeLoop() {
    let eventId = setInterval(() => {
    });
}
function initResizeHandlers() {
    const $tables = $('.table.embedded');
    const $tableArr = $tables.toArray().map(tableDiv => $(tableDiv));
    const mouse = { x: -1, y: -1 };
    $(document).on('mousemove', (event) => {
        mouse.x = event.pageX;
        mouse.y = event.pageY;
    });
    let eventId = -1;
    $tableArr.map($t => {
        const $resizeHandleArr = $t.find('.resize-handle:not(.z-done)').toArray().map(ele => $(ele));
        // const dfltOffset = $resizeHandleArr.length ? $resizeHandleArr[0].offset().left : 0
        $resizeHandleArr.map(($resize, i) => {
            const resizeWidth = $resize.width();
            $resize.on('mousedown', (e) => {
                var _a, _b, _c;
                e.preventDefault();
                e.stopPropagation();
                console.log('mousedown', e);
                const $hcol = $resize.parent();
                const $trows = $t.find('.tbody .tr').toArray().map(ele => $(ele));
                const $bcolArr = $trows.map($bcol => $bcol.children().eq($hcol.index()));
                // const minWidth = Number($hcol.css('min-width').replace('px', '') || 0)
                // console.log({ minWidth })
                const tableOffset = $t.offset().left;
                const leftColumn = $resizeHandleArr[i - 1] !== undefined ? (((_b = (_a = $resizeHandleArr[i - 1]) === null || _a === void 0 ? void 0 : _a.offset()) === null || _b === void 0 ? void 0 : _b.left) || 0) - (((_c = $resizeHandleArr[i - 1]) === null || _c === void 0 ? void 0 : _c.width()) || tableOffset) : tableOffset;
                // const initialRightAnchor = $resize.offset().left
                eventId = setInterval(() => {
                    let rightAnchor = $resize.offset().left;
                    const delta = Math.round((mouse.x - leftColumn - (resizeWidth)) * 10.0) / 10.0;
                    console.log(rightAnchor, mouse.x, delta);
                    $hcol.css('flex-basis', delta + 'px');
                    // $hcol.css('flex', '1 1 0%')
                    $hcol.css('width', '');
                    $bcolArr.map($bcol => {
                        $bcol.css('flex-basis', delta + 'px');
                        // $bcol.css('flex', '1 1 0%')
                        $bcol.css('width', '');
                    });
                }, 100);
            });
            $resize.addClass('z-done');
        });
        const $allCols = $t.find('.tr-head .th,.tbody .td');
        $allCols.css('min-width', '60px');
        // $allCols.css('flex-basis', '60px')
        $allCols.css('width', 'fit-content');
        const width = $t.width() / $allCols.filter('.th').length;
        $allCols.css('flex-basis', '');
        const $cols = $allCols.filter('.td');
        const maxWidths = {};
        $cols.toArray().map(c => $(c)).map(($c) => {
            const i = $c.index();
            if (!maxWidths.hasOwnProperty(i)) {
                maxWidths[i] = -1;
            }
            if (maxWidths[i] < $c.innerWidth()) {
                maxWidths[i] = $c.innerWidth();
            }
        });
        Object.keys(maxWidths).map(key => {
            if (maxWidths[key] === -1) {
                delete maxWidths[key];
            }
        });
        console.log(maxWidths);
        const lastColIndex = Number(Object.keys(maxWidths).pop());
        const leftCols = Object.keys(maxWidths).slice(0, -1).map(k => maxWidths[k]).reduce((a, b) => a + b, 0);
        const lastWidth = $t.width() - leftCols - 10; // - 10 for scrollbar
        maxWidths[lastColIndex] = lastWidth;
        let changeIndex = 1;
        if (changeIndex !== lastColIndex) {
            const tmp = maxWidths[changeIndex];
            maxWidths[changeIndex] = maxWidths[lastColIndex];
            maxWidths[lastColIndex] = tmp;
        }
        $allCols.toArray().map(c => $(c)).map(($c) => {
            const horizontal = $c.index();
            $c.css('flex-basis', maxWidths[horizontal]);
        });
        $allCols.css('width', '');
        // const width = $t.width() / $allCols.filter('.th').length
        // $allCols.css('flex-basis', width)
        // $cols.css('flex', '1 1 0%')
        $t.removeClass('loading');
    });
    $(document).on('mouseup', (e) => {
        console.log('mouseup', e);
        if (eventId !== -1) {
            clearInterval(eventId);
        }
    });
}
globalThis.initResizeHandlers = initResizeHandlers;
export const page_publications = {
    requiresAuth: true,
    run: run,
};
//# sourceMappingURL=publications.js.map